import BaseAvatar, { IBaseAvatar } from "@Components/common/byb-ds/base-avatar";
import League from "@Enums/Leagues";
import { getLeagueColor } from "@Helpers/league-utils";
import { getMedalBackgroundColor } from "@Helpers/medal-utils";
import { CircularProgress, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";

interface IMobileAvatar extends IBaseAvatar {
  size?: number;
  league?: League;
}

const MobileAvatar = ({ src, user, size = 10, league }: IMobileAvatar) => {
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"));
  const [loading, setLoading] = useState(!!src);

  const handleImageLoad = () => setLoading(false);
  const handleImageError = () => setLoading(false);

  const commonStyles = {
    width: `${size * 20}px`,
    height: `${size * 20}px`,
    fontSize: `${size * 8}px`,
    border: isMdDown ? `${size}px solid ${theme.palette.dsBase.v100}` : "none",
    ...(league && {
      border: "4px solid transparent",
      background: `${getMedalBackgroundColor(league, theme)} padding-box, ${getLeagueColor(league, theme)} border-box`,
    }),
  };

  return (
    <BaseAvatar
      src={src}
      user={user}
      sx={commonStyles}
      slotProps={{
        img: {
          loading: "lazy",
          onLoad: handleImageLoad,
          onError: handleImageError,
        },
      }}
    >
      {loading && (
        <CircularProgress
          size={theme.spacing(size / 2)}
          sx={{ position: "absolute", color: theme.palette.primary.main }}
        />
      )}
    </BaseAvatar>
  );
};

export default MobileAvatar;
